import React from "react";
const BuyPanel = () => {
  return (
    <div>
      <div className="alert alert-info" role="alert">
        <h4 className="alert-heading">خرید پنل اس ام اس سایه بان</h4>
        <p className="text-bold"></p>
        <hr />
        <p className="mb-0 text-justify" style={{ fontSize: "18px" }}>
          سامانه پیام کوتاه سایه بان از سال ۱۳۹۸ فعالیت رسمی خود را در زمینه
          تبلیغات پیامکی شروع کرده است.
          <br /> و تمام تلاش خود را برای ارائه بروزترین و پیشرفته ترین سامانه
          ارسال پیامک بکار گرفته است. و هم اکنون یکی از کاملترین سامانه های کشور
          را باتوجه به نیاز روز کاربران ارائه میکند.
          <br /> مفتخریم که درحال حاضر قادر به ارایه کمترین تعرفه ارسال پیامک در
          کشور، هرپیامک ۹۵ ریال میباشد. و اما پنل اس ام اس چیست؟ یا همان پنل
          ارسال پیامک انبوه یا هر عنوان مشابه دیگری درواقع یک برنامه تحت وب جهت
          ارسال پیامک چه بصورت تکی، گروهی، انبوه یا هوشمند میباشد. برنامه تحت وب
          به این معنی که شما نیازی به نصب و اجرای نرم افزار خاصی ندارید و برنامه
          در سرور ما روی سایت نصب شده است و شما با تهیه پنل درواقع یک شناسه و
          رمز عبور مخصوص خود را دریافت میکنید و از قسمت ورود به سامانه با این
          مشخصات وارد محیط پنل ارسال پیامک شده و به تمام منوها و امکانات موجود
          جهت ارسال پیامک دسترسی خواهید داشت.
          <br />
          پنل های پیامک با امکانات، تعرفه و هزینه اولیه مختلف برای نیازها و
          بودجه های مختلف پکیچ بندی شده است، ابتدا امکانات و تعرفه پنل ها را
          بررسی کنید و با توجه به نیاز و بودجه تان پنل ارسال اس ام اس خود را
          انتخاب کنید، ناگفته نماند که اگر تعداد ارسال بالایی خواهید داشت، پنل
          های بالاتر بعلت تعرفه ارسال کم در نهایت برای شما مقرون به صرفه تر
          خواهند بود. البته در صورتیکه پنل پایین تر تهیه کردید، در آینده با
          پرداخت مبلغ مابه تفاوت قابل ارتقاء به پلن بالاتر می باشد. برای فعال
          شدن پنل ضروری است که از داخل سامانه اسکن کارت ملی را بارگذاری کنید، پس
          موقع ثبت نام مشخصات صحیح خود را وارد کنید. بعد از فعال شدن پنل خطوط
          رند عمومی به طور خودکار به پنل شما اضافه خواهند شد و می توانید از آنها
          برای ارسال اس ام اس استفاده کنید. درصورت تمایل و نیاز می توانید از
          منوی عملیات حساب /خرید شماره دو عدد خط ۱۴ رقمی بصورت رایگان از
          اپراتورهای ۵۰۰۰۱ و ۵۰۰۰۲ ثبت کنید.در صورتیکه برای ارسال های خود نیاز
          به خط خدماتی دارید یک تیکت برای واحد پشتیبانی ارسال کنید تا خطوط
          خدماتی بصورت رایگان برای شما اضافه شوند. اگر قصد استفاده ار پنل در
          افزونه های پیامکی آماده مانند وردپرس ، ووکامرس، whmcs و … دارید از
          منوی خدمات وبسرویس داخل پنل افزونه های آماده قابل دانلود هستند. و اگر
          هم افزونه پیامکی اختصاصی خودتان مثلا برای اپلیکیشن مخصوصتان می خواهید
          بنویسید ، می توانید از مستندات وبسرویس سامانه در منوی آزمایشگاه
          استفاده کنید. وب سرویس API در تمام پنل ها بطور پیش فرض بصورت رایگان
          فعال می باشد.
        </p>
      </div>
    </div>
  );
};

export default BuyPanel;
